import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, API, formatApiErrorDetail } from "@/lib/api";
import Seo from "@/components/site/Seo";
import { FileDown, ShieldCheck, Layers, Clock } from "lucide-react";
import { toast } from "sonner";

export default function PriceList() {
  const [form, setForm] = useState({ name: "", company_name: "", phone: "", email: "" });
  const [url, setUrl] = useState(null);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));
  const submit = async () => {
    if (!form.name || !form.phone) return toast.error("Name and phone are required");
    setBusy(true);
    try {
      const r = await api.post("/price-list/request", { ...form, email: form.email || null });
      setUrl(`${API}${r.data.url.replace(/^\/api/, "")}`);
      toast.success("Your price list is ready");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div>
      <Seo page="price-list"/>
      <div className="bg-[#0F172A] text-white py-12"><div className="container-x">
        <h1 className="font-heading font-extrabold text-3xl sm:text-4xl">Wholesale Price List</h1>
        <p className="text-slate-300 mt-2 max-w-2xl">Download our branded wholesale price list PDF covering laptops, desktops, parts, accessories, storage and networking.</p>
      </div></div>
      <div className="container-x py-12 grid md:grid-cols-2 gap-8">
        <div className="space-y-4">
          {[[Layers, "Complete catalogue", "All active products with SKU, brand, category and condition."],
            [ShieldCheck, "Dealer-friendly pricing", "Indicative wholesale prices; final rates confirmed on enquiry."],
            [Clock, "Always current", "Generated live from our catalogue the moment you download."]].map(([I, h, t]) => (
            <div key={h} className="bg-white border border-[#E2E8F0] rounded-md p-5 flex gap-3">
              <I className="w-6 h-6 text-[#EA580C] shrink-0"/><div><div className="font-semibold">{h}</div><div className="text-slate-600 text-sm">{t}</div></div>
            </div>
          ))}
        </div>
        <div className="bg-white border border-[#E2E8F0] rounded-md p-6 space-y-3" data-testid="price-list-form">
          {url ? (
            <div className="text-center py-6 space-y-4">
              <FileDown className="w-12 h-12 text-[#EA580C] mx-auto"/>
              <h3 className="font-heading font-bold text-xl">Thank you, {form.name}!</h3>
              <p className="text-slate-600 text-sm">Your wholesale price list is ready to download.</p>
              <a href={url} target="_blank" rel="noreferrer" data-testid="price-list-download-link"><Button className="btn-orange" size="lg">Download PDF</Button></a>
            </div>
          ) : (<>
            <h3 className="font-heading font-bold text-xl">Get the price list</h3>
            <p className="text-sm text-slate-600">Leave your business details and download instantly.</p>
            <div><Label>Name *</Label><Input data-testid="pl-name" value={form.name} onChange={set("name")}/></div>
            <div><Label>Company / Shop</Label><Input data-testid="pl-company" value={form.company_name} onChange={set("company_name")}/></div>
            <div><Label>Phone *</Label><Input data-testid="pl-phone" value={form.phone} onChange={set("phone")}/></div>
            <div><Label>Email</Label><Input data-testid="pl-email" type="email" value={form.email} onChange={set("email")}/></div>
            <Button className="btn-orange w-full" onClick={submit} disabled={busy} data-testid="pl-submit">{busy ? "Preparing..." : "Get Price List PDF"}</Button>
          </>)}
        </div>
      </div>
    </div>
  );
}
